import { Box, Divider, Heading, Hidden, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import { FeatureItem } from '../../../feature-item/feature-item';
import { PricingInfo } from '../../../pricing-info/pricing-info';
import css from './pricing-plan-header.module.css';
import type { Teams } from 'types/pricing';
type PricingPlanHeaderProps = {
  size: 'base' | 'sm';
  planName: Teams.PricingPlan;
};
function PricingPlanHeader({
  planName,
  size = 'base'
}: PricingPlanHeaderProps) {
  const {
    t
  } = useTranslation('pricing_v2_3');
  return <Box className={css.planHeaderContainer} data-sentry-element="Box" data-sentry-component="PricingPlanHeader" data-sentry-source-file="pricing-plan-header.tsx">
            <Box className={cn(css.contentContainer, css[size])} data-sentry-element="Box" data-sentry-source-file="pricing-plan-header.tsx">
                <Image src={`/static/pricing/${planName}.svg`} alt="" width={75} height={100} className={css.planImage} data-sentry-element="Image" data-sentry-source-file="pricing-plan-header.tsx" />
                <Box className={css.textContainer} data-sentry-element="Box" data-sentry-source-file="pricing-plan-header.tsx">
                    <Heading level="2" size={`major-${size}`} data-sentry-element="Heading" data-sentry-source-file="pricing-plan-header.tsx">
                        {t(`plans.names.${planName}`)}
                    </Heading>
                    <Text size={`body-${size}`} weight="medium" className={css.colorSecondary} data-sentry-element="Text" data-sentry-source-file="pricing-plan-header.tsx">
                        {t(`plans.common.${planName}`)}
                    </Text>
                </Box>
            </Box>
            <Box className={css.pricingContainer} data-sentry-element="Box" data-sentry-source-file="pricing-plan-header.tsx">
                <Box className={css.additionalInfo} data-sentry-element="Box" data-sentry-source-file="pricing-plan-header.tsx">
                    {planName === 'teams' ? <FeatureItem name={t('plans.common.starter')} description={t('plans.common.starterThen')} toggleVisible={true} iconColor={'tertiary'} variant="sm" /> : <Hidden below="md">
                            <Box className="pbs-24" />
                        </Hidden>}
                </Box>

                <PricingInfo plan={planName} data-sentry-element="PricingInfo" data-sentry-source-file="pricing-plan-header.tsx" />
                <Hidden below="md" data-sentry-element="Hidden" data-sentry-source-file="pricing-plan-header.tsx">
                    <Divider data-sentry-element="Divider" data-sentry-source-file="pricing-plan-header.tsx" />
                </Hidden>
            </Box>
        </Box>;
}
export { PricingPlanHeader };